'use strict';

import { Helper } from "../helpers/Helper.js";

export class DonationVariation {
	constructor() {
		this.#addEventListeners();
	}

	#addEventListeners() {
		const categoryWrappers = document.querySelectorAll('.category-wrapper');
		const selectFields = document.querySelectorAll('select[id^="levcharity_selected_category_name_"]');
		categoryWrappers.forEach((wrapper) => {
			const inputField = wrapper.querySelector('input[id^="levcharity_variation_category_"]');
			const hiddenLabelInput = wrapper.querySelector('input[id^="variation_category_label_"]');
			if (inputField && selectFields.length > 0) {
				inputField.addEventListener('keypress', (event) => this.#handleKeyPress(event, inputField, selectFields, hiddenLabelInput));
			}

			selectFields.forEach(selectField => {
				const correspondingWrapper = selectField.closest('.category-wrapper');
				const correspondingHiddenLabelInput = correspondingWrapper.querySelector('input[id^="variation_category_label_"]');
				correspondingHiddenLabelInput.value = selectField.options[selectField.selectedIndex].text;
				selectField.addEventListener('change', () => {
					correspondingHiddenLabelInput.value = selectField.options[selectField.selectedIndex].text;
				});
			});
		});
	}

	#handleKeyPress(event, inputField, selectFields, hiddenLabelInput) {
		if (event.key === 'Enter') {
			event.preventDefault();
			const newCategoryValue = Helper.slugify(inputField.value.trim()) || '-';
			const newCategoryName = inputField.value.trim();
			if (newCategoryName !== '') {
				selectFields.forEach(selectField => {
					// Remove existing options with the same value
					Array.from(selectField.options).forEach(option => {
						if (option.value === newCategoryValue) {
							selectField.removeChild(option);
						}
					});

					// Create new option and add it to the select field
					const option = document.createElement('option');
					option.value = newCategoryValue;
					option.text = newCategoryName;

					// Append the new option without setting it as selected
					selectField.appendChild(option);
				});

				inputField.value = '';
			}
		}
	}
}
